import {createReducer} from 'redux-create-reducer';
import {Actions} from '../constants';

export default createReducer({}, {
    [Actions.LOGIN_USER_REQUEST](loginState, action) {

        return loginState.merge({loggedIn:false, loginAborted:false, loginProgress:'user'});
    },
    [Actions.LOGIN_SERVER_REQUEST](loginState, action) {

        return loginState.merge({loggedIn:false, loginProgress:'server'});
    },
    [Actions.LOGIN_SUCCESS](loginState, action) {

        return loginState.merge({loggedIn:true, loginProgress:null, errorMessage:""});
    },
    [Actions.LOGIN_FAILURE](loginState, action) {

        return loginState.merge({loggedIn:false, loginProgress:'server-failed', errorMessage:action.payload.message});
    },
    [Actions.LOGIN_ABORT](loginState, action) {

        return loginState.merge({loggedIn:false, loginProgress:null, loginAborted:true, errorMessage:""});
    },
    [Actions.LOGOUT_REQUEST](loginState, action) {

        return loginState.merge({loggedIn:false, loginProgress:'logout', loginAborted:false});
    },
    [Actions.LOGOUT_SUCCESS](loginState, action) {

        return loginState.merge({loggedIn:false, loginProgress:null, loginAborted:true, errorMessage:""});
    },
});



// WEBPACK FOOTER //
// ./src/model/reducers/login-reducer.js